import React, { useEffect, useState } from "react";

import NavigationButton from "../NavigationButton/NavigationButton";
import ComparerIndicator from "../ComparerIndicator/ComparerIndicator";
import { GoArrowRight } from "react-icons/go";
import { OnNavigateFunction } from "types/ListAndDetailTypes";
import { ActiveComponentEnum } from "enums/enums";
import Const from "const.json";
import { EntityComplaint } from "types/EntityComplaint";
import Logo from "components/ui/Logo";
import { numberWithCommas } from "utils/utils";

interface DetailHeaderProps {
  onNavigate: OnNavigateFunction;
  complaint: EntityComplaint;
  isShowDetails: boolean;
  navigateTo: ActiveComponentEnum;
  isShowLogo: boolean;
  isFullSubHeader?: boolean;
  isShowTextInIcon?: boolean;
  sumComplaints?: number;
}
const DetailHeader: React.FC<DetailHeaderProps> = ({
  onNavigate,
  complaint,
  isShowDetails,
  isShowLogo,
  navigateTo,
  isFullSubHeader = false,
  isShowTextInIcon = true,
  sumComplaints = 0,
}) => {
  const [fullSubHeader, setFullSubHeader] = useState("");

  useEffect(() => {
    if(complaint.comparerData)
      setFullSubHeader(
        ` ${
          complaint.comparerData.isIncrease ? Const.increase : Const.decrease
        } ${Const.comparedTo} ${numberWithCommas(complaint.comparerData.changeAmount)} ${
          Const.complaints
        } ${Const.thePreviousYear}`
      );
  }, []);

  return (
    <div className="grey-border-bottom details-header">
      <div className="nav-button-style">
        <NavigationButton
          iconFirst={true}
          navigateTo={navigateTo}
          text={Const.backTo}
          icon={<GoArrowRight />}
          iconLabel={Const.rightIcon}
          onNavigate={onNavigate}
        />
      </div>
      {isShowDetails && (
        <div className="list-item-content">
          {isShowLogo && (
            <Logo
              className="iconDetails"
              alt={`${complaint.description + " logo"}`}
              src={complaint.id}
              defaultLogo={complaint.type}
            />
          )}
          <div>
            <h3>{complaint.description}</h3>
            <div className="d-flex align-items-center">
              <h5 className="ps-3" >
                {`${numberWithCommas(sumComplaints ? sumComplaints : complaint.complaintsCount)} ${Const.complaints} `}
              </h5>
              {complaint.comparerData && (
                <ComparerIndicator
                  isShowTextInIcon={isShowTextInIcon}
                  comparerData={{
                    isDisplayPercent: complaint.comparerData.isDisplayPercent,
                    isIncrease: complaint.comparerData.isIncrease,
                    changeAmount: complaint.comparerData.changeAmount,
                  }}
                />
              )}
              <span>{isFullSubHeader && fullSubHeader}</span>
            </div>
          </div>
        </div>
      )}
      {!isShowDetails && (
        <div>
          <span className="boldHeader">
            {complaint.description}
          </span>
        </div>
      )}
    </div>
  );
};

export default DetailHeader;
